import React, { useState } from "react";
import nubmer from "../../../assets/images/home/number3.png";
// off
import lottemart from "../../../assets/images/home/brand/sell_lottemart.png";
import homeplus from "../../../assets/images/home/brand/sell_homeplus.png";
import ymart from "../../../assets/images/home/brand/sell_ymart.png";
import emart from "../../../assets/images/home/brand/sell_emart.png";
import costco from "../../../assets/images/home/brand/sell_costco.png";
// on
import kakaomarket from "../../../assets/images/home/brand/sell_kakao.png";
import auction from "../../../assets/images/home/brand/sell_auction.png";
import gmarket from "../../../assets/images/home/brand/sell_gmarket.png";
import elevenst from "../../../assets/images/home/brand/sell_11st.png";
import navermarket from "../../../assets/images/home/brand/sell_naver.png";
import makers from "../../../assets/images/home/brand/sell_m.png";
// sns
import instagram from "../../../assets/images/home/brand/sns_instagram.png";
import facebook from "../../../assets/images/home/brand/sns_facebook.png";
import kakao from "../../../assets/images/home/brand/sns_kakao.png";
export const Sell = () => {
  return (
    <section>
      <div className="bg-white h-auto pb-20 base:pb-0 base:h-screen overflow-hidden flex flex-wrap content-center w-full pt-20 base:pt-24">
        <div className="lg:max-w-screen-lg lg:m-auto sm:m-6 m-4 base:max-w-none w-full">
          <div className="sectionHeader pb-8 md:pb-16 flex flex-wrap flex-col base:flex-row base:justify-between">
            <div className="numbering">
              <img
                src={nubmer}
                alt="3 판매라인"
                className="mx-auto base:m-0 h-36 base:h-auto"
              />
            </div>
            <div className="headText flex flex-col flex-wrap justify-center text-center base:text-right">
              <h2 className="text-2xl sm:text-3xl base:text-5xl leading-normal base:leading-normal font-bold">
                촘촘한 유통망으로
                <br />
                전국 어디서나 편리하게
              </h2>
            </div>
          </div>
          <div className="sectionBody flex flex-col gap-y-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-5">
              <div className="marketBox">
                <div className="boxHeader h-16 flex flex-wrap content-center justify-center text-lg base:text-2xl leading-normal font-bold">
                  오프라인
                </div>
                <div className="boxBody h-36 flex flex-wrap content-center justify-center">
                  <div className="text-center">
                    <img
                      className="inline-block base:m-5 base:h-auto h-5 m-3"
                      src={lottemart}
                      alt="롯데마트로고"
                    />
                    <img
                      className="inline-block base:m-5 base:h-auto h-5 m-3"
                      src={homeplus}
                      alt="홈플러스로고"
                    />
                    <img
                      className="inline-block base:m-5 base:h-auto h-5 m-3"
                      src={ymart}
                      alt="와이마트로고"
                    />
                    <img
                      className="inline-block base:m-5 base:h-auto h-5 m-3"
                      src={emart}
                      alt="이마트로고"
                    />
                    <img
                      className="inline-block base:m-5 base:h-auto h-5 m-3"
                      src={costco}
                      alt="코스트코로고"
                    />
                  </div>
                </div>
              </div>
              <div className="marketBox">
                <div className="boxHeader h-16 flex flex-wrap content-center justify-center text-lg base:text-2xl leading-normal font-bold">
                  온라인
                </div>
                <div className="boxBody h-36 flex flex-wrap content-center justify-center">
                  <div className="text-center">
                    <img
                      className="inline-block base:m-3 base:w-14 w-12 m-2"
                      src={kakaomarket}
                      alt="카카오마켓로고"
                    />
                    <img
                      className="inline-block base:m-3 base:w-14 w-12 m-2"
                      src={auction}
                      alt="옥션로고"
                    />
                    <img
                      className="inline-block base:m-3 base:w-14 w-12 m-2"
                      src={gmarket}
                      alt="지마켓로고"
                    />
                    <img
                      className="inline-block base:m-3 base:w-14 w-12 m-2"
                      src={elevenst}
                      alt="11번가로고"
                    />
                    <img
                      className="inline-block base:m-3 base:w-14 w-12 m-2"
                      src={navermarket}
                      alt="네이버마켓로고"
                    />
                    <img
                      className="inline-block base:m-3 base:w-14 w-12 m-2"
                      src={makers}
                      alt="메이커스로고"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-5 gap-y-5">
              <div className="marketBox">
                <div className="boxHeader h-16 flex flex-wrap content-center justify-center text-lg base:text-2xl leading-normal font-bold">
                  SNS
                </div>
                <div className="boxBody h-36 flex flex-wrap content-center justify-center">
                  <div className="text-center">
                    <img
                      className="inline-block base:m-3 base:w-14 w-12 m-2"
                      src={instagram}
                      alt="인스타그램로고"
                    />
                    <img
                      className="inline-block base:m-3 base:w-14 w-12 m-2"
                      src={facebook}
                      alt="페이스북로고"
                    />
                    <img
                      className="inline-block base:m-3 base:w-14 w-12 m-2"
                      src={kakao}
                      alt="카카오톡로고"
                    />
                  </div>
                </div>
              </div>
              <div className="marketBox">
                <div className="boxHeader h-16 flex flex-wrap content-center justify-center text-lg base:text-2xl leading-normal font-bold">
                  조달
                </div>
                <div className="boxBody h-36 flex flex-wrap content-center justify-center">
                  <p className="text-lg base:text-2xl base:space-x-5 space-x-4">
                    <span className="inline-block">나라장터</span>
                    <span className="inline-block">S2B</span>
                  </p>
                </div>
              </div>
              <div className="marketBox">
                <div className="boxHeader h-16 flex flex-wrap content-center justify-center text-lg base:text-2xl leading-normal font-bold">
                  수출＆기타
                </div>
                <div className="boxBody h-36 flex flex-wrap content-center justify-center">
                  <span className="px-3 py-1 m-1 text-base base:m-2 base:text-lg base:px-4 base:py-2 inline-block border border-gray-300 base:rounded-2xl rounded-xl ">
                    미국
                  </span>
                  <span className="px-3 py-1 m-1 text-base base:m-2 base:text-lg base:px-4 base:py-2 inline-block border border-gray-300 base:rounded-2xl rounded-xl ">
                    동아시아
                  </span>
                  <span className="px-3 py-1 m-1 text-base base:m-2 base:text-lg base:px-4 base:py-2 inline-block border border-gray-300 base:rounded-2xl rounded-xl ">
                    호주
                  </span>
                  <span className="px-3 py-1 m-1 text-base base:m-2 base:text-lg base:px-4 base:py-2 inline-block border border-gray-300 base:rounded-2xl rounded-xl ">
                    일본
                  </span>
                  <span className="px-3 py-1 m-1 text-base base:m-2 base:text-lg base:px-4 base:py-2 inline-block border border-gray-300 base:rounded-2xl rounded-xl ">
                    유럽
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
